import React from "react";
import "./PrivacyPolicy.scss";

const PrivacyPolicy = () => {
  return (

    <div style={{ padding: "20px", lineHeight: "1.6" }}>
      <h1>CALL CENTRAL PRIVACY POLICY</h1>

      <p><strong>[CALL CENTRAL APPLICATION]</strong></p>
      <p>Last updated: December, 2020</p>

      <p>
        We respects the privacy of our users. This Privacy Policy explains how we collect,
        use, disclose, and safeguard your information when you visit our CALL CENTRAL application.
        Please note that you may not use the Services if you are younger than 13 years old.
      </p>

      <p>
        IF YOU DO NOT AGREE WITH THE TERMS OF THIS PRIVACY POLICY, PLEASE DO NOT ACCESS THE APPLICATION.
      </p>

      <h2>COLLECTION OF YOUR INFORMATION</h2>
      <p>
        We may collect information about you in a variety of ways...
      </p>

      <h3>Personal Data</h3>
      <p>
        The Personal Information we collect is used for such purposes as setting up and personalizing your account...
      </p>

      <h3>Mobile Device Access</h3>
      <p>
        We may request access or permission to certain features from your mobile device, including camera and microphone.
      </p>

      <h3>Push Notifications</h3>
      <p>
        We may request to send you push notifications regarding your account or the Application.
      </p>

      <h2>CONTACT US</h2>
      <p>Email: md@mdhani.com</p>
      <p>Phone: +1 262-242-5725</p>
    </div>
  );
};

export default PrivacyPolicy;